export const InboxRoute = {
  DASHBOARD: {
    path: 'inbox',
    name: 'inbox'
  }
};
